import { minLength, regex, required } from 'react-admin'

const nameValidator = regex(
  /^[а-яА-ЯёЁa-zA-Z0-9]+$/,
  'использованы запрещенные символы'
)

export const promoNameValidator = [nameValidator, required(), minLength(5)]
